import type { IconNode } from '../types';

/**
 * @name id-card
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMgMTlhNCA0IDAgMDAtOCAwIiAvPgogIDxwYXRoIGQ9Ik0xNiAxMGgyIiAvPgogIDxwYXRoIGQ9Ik0xNiAxNGgyIiAvPgogIDxjaXJjbGUgY3g9IjkiIGN5PSIxMiIgcj0iMyIgLz4KICA8cmVjdCB4PSIyIiB5PSI1IiB3aWR0aD0iMjAiIGhlaWdodD0iMTQiIHJ4PSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/id-card
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const IdCard: IconNode = [
  ['path', { d: 'M13 19a4 4 0 00-8 0' }],
  ['path', { d: 'M16 10h2' }],
  ['path', { d: 'M16 14h2' }],
  ['circle', { cx: '9', cy: '12', r: '3' }],
  ['rect', { x: '2', y: '5', width: '20', height: '14', rx: '2' }],
];

export default IdCard;
